// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: '',
  // APIUrl: "http://127.0.0.1:8000/api/",
  // BaseUrl: "http://127.0.0.1:8000",

  // APIUrl:'http://15.206.149.28/api/',
  // BaseUrl:'http://15.206.149.28'

  // BaseUrl: 'https://flexhire.in',
  // APIUrl: 'https://flexhire.in/api/',

  BaseUrl: 'https://api.flexpros.in',
  APIUrl: 'https://api.flexpros.in/api/',

  // BaseUrl: 'https://dev.flexpros.in',
  // APIUrl: 'https://dev.flexpros.in/api/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
